import React, { useState, useRef, useEffect } from "react";
import { HelpCircle } from "lucide-react";
import "./hotelInventory.css";

const HelpTip = ({ title, children, align = "left" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [open]);

  return (
    <span className="hi-help" ref={ref}>
      <button type="button" className="hi-help-btn" title="How this works" onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}>
        <HelpCircle size={16} />
      </button>
      {open && (
        <div className={`hi-help-pop ${align}`} onClick={(e) => e.stopPropagation()}>
          {title ? <div className="hi-help-ttl">{title}</div> : null}
          <div className="hi-help-body">{children}</div>
        </div>
      )}
    </span>
  );
};

export default HelpTip;
